import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useRightSidebarStore } from "../stores/rightSidebarStore";
import { AddToAlbum } from "./RightSidebar/AddToAlbum";
import { AddToPlaylist } from "./RightSidebar/AddToPlaylist";
import { EqualizerSettings } from "./RightSidebar/EqualizerSettings";
import { HapticsSettings } from "./RightSidebar/HapticsSettings";

export const RightSidebar = () => {
  const { isOpen, content, closeSidebar } = useRightSidebarStore();

  const renderContent = () => {
    switch (content) {
      case "haptics":
        return <HapticsSettings />;
      case "equalizer":
        return <EqualizerSettings />;
      case "addToPlaylist":
        return <AddToPlaylist />;
      case "addToAlbum":
        return <AddToAlbum />;
      default:
        return null;
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 z-50"
            onClick={closeSidebar}
          />
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", damping: 20 }}
            className="fixed right-0 top-0 bottom-0 md:bottom-0 bottom-[60px] w-full max-w-md bg-zinc-900 shadow-xl z-50 flex flex-col"
          >
            <div className="flex items-center justify-between p-6 border-b border-zinc-800">
              <h2 className="text-xl font-bold">
                {content === "haptics" && "Haptic Settings"}
                {content === "equalizer" && "Equalizer"}
                {content === "addToPlaylist" && "Add to Playlist"}
                {content === "addToAlbum" && "Add to Album"}
              </h2>
              <button onClick={closeSidebar} className="p-2 hover:bg-zinc-800 rounded-full transition">
                <X className="w-6 h-6" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto">{renderContent()}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
